import React, { useState, useEffect, useLayoutEffect, useRef, useMemo, useCallback } from "react";
import "./style.css";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import { Avatar, Box, Skeleton, Typography } from "@mui/material";
import Input from "../../../common/InputField";
import GeneralSale from "./GeneralSale";
import EditAgentStatus from "./EditAgentStatus";
import AvalibityProfile from "./AvalibityProfile";
import RoleAgent from "./RoleAgent";
import EditProfileEmail from "./EditProfileEmail";
import TeamInputNumber from "./TeamInput";
import CoUserGroup from "./CoUserGroup";
import { ReactComponent as GreenDot } from "../../../../assets/images/green-dot.svg";
import { ReactComponent as RedDot } from "../../../../assets/images/red-dot.svg";
import { ReactComponent as GreyDot } from "../../../../assets/images/grey-dot.svg";
import { ReactComponent as BACKBUTTON } from "../../../../assets/images/backbutton.svg";
import { ReactComponent as EDITLOGO } from "../../../../assets/images/editgroup.svg";
import PasswordField from "../../../common/passwordInput";
import { updateCoUserApi } from "../../../../store/features/CoUserUpdate";
import { buildCoUserProfileUpdateFormData } from "../../../../utils/agentMappers";
import { suspendUserApi } from "../../../../store/features/suspendCoUser";
import { deleteUserApi } from "../../../../store/features/deleteCoUser";
import { ListUserIndApi } from "../../../../store/features/listCoUserIndividual";
import { listWorkingHoursApi } from "../../../../store/features/listWorkingHours";
import { updateUser } from "../../../../store/features/loginUser";
import ProfileSettingsUnifiedSkeleton from "./ProfileSettingsSkeleton";
import { BASE_URL } from "../../../../api/ApiConfig";
import { createAppSocket } from '../../../../api/createAppSocket';
import KnowledgeBaseRole from "./KnowledgeBaseRole";
import { clsx } from "clsx";
import {
  getProfileWarmBootstrapForUser,
  getProfileWarmEntry,
  mergeProfileSettingsWarmCache,
} from "../../../../utils/profileSettingsWarmCache";
const ENDPOINT = `${BASE_URL}`;
function EditProfileMain(props) {
  const showProfileComponent = props.showProfileComponent ?? true;
  const dispatch = useDispatch();
  const routeParams = useParams();
  const userData = useSelector((state) => state.loginToken);
  const coUserData = useSelector((state) => state.loginTokenCoUser);
  const uID = userData.response?.user?._id || coUserData?.response?.user?._id;
  const userId = props.userId ?? routeParams.userId ?? uID;

  const fileInputRef = useRef(null);
  const [jobTitle, setJobTitle] = useState("");
  const [initialProfile, setInitialProfile] = useState({});
  const [userName, setUserName] = useState("");
  const [agentName, setAgentName] = useState("");
  const [addGroupGeneral, setAddGroupGeneral] = useState([]);
  const [editLogoSrc, setEditLogoSrc] = useState(null);
  const [getChatLimit, setGetChatLimit] = useState();
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [addNewGrouptoUser, setAddNewGroupUser] = useState([]);

  const [userRole, setUserRole] = useState("");
  const [image, setImage] = useState(null);
  const [userLogo, setUserLogo] = useState();
  const [touchedFields, setTouchedFields] = useState({
    userName: false,
    jobTitle: false,
    userEmail: false,
    chatLimit: false,
    userLogo: false,
    // add more fields if needed
  });
  const [chatLimit, setChatLimit] = useState(3);
  const [userUpdate, setUserUpdate] = useState("");
  const [coUserRoleId, setCoUserRoleId] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userPassword, setUserPassword] = useState("");
  const [workingData, setWorkingData] = useState([]);
  const [activeEditAgentId, setActiveEditAgentId] = useState(null);
  const [isLoadingUser, setIsLoadingUser] = useState(
    !getProfileWarmBootstrapForUser(userId).profileReady
  );
  const [isLoadingWorkingHours, setIsLoadingWorkingHours] = useState(
    !getProfileWarmBootstrapForUser(userId).hoursReady
  );
  const [isUpdating, setIsUpdating] = useState(false);
  const [acceptChat, setAcceptChat] = useState(false);
  const [isOffline, setIsOffline] = useState(false);
  const [isStatusLoading, setIsStatusLoading] = useState(false);
  const navigate = useNavigate();
  const [stateName, setStateName] = useState({
    nameInvalid: false,
    nameInvalidMessage: "",
    nameState: false,
  });

  const specialCharacterRegex = /[^a-zA-Z0-9 ]| {2,}|^[ ]|[ ]$/;

  const applyUserListItemToState = useCallback((item) => {
    if (!item) return;
    setAcceptChat(item?.accept_chat);
    setIsOffline(item?.is_offline);
    setUserKBRole(item.kbRole?.role);
    setIsStatusLoading(false);
    setUserName(item.full_name);
    setAgentName(item.full_name);
    setUserEmail(item.email);
    setJobTitle(item.job_title || "");
    setUserLogo(item.agent_image);
    setGetChatLimit(item.agent_chat_limit);
    setInitialProfile({
      userName: item.full_name,
      userEmail: item.email,
      userLogo: item.agent_image,
      chatLimit: item.agent_chat_limit,
      jobTitle: item.job_title || "",
      userRole: item.role_name,
    });
    setAddGroupGeneral([]);
    (item.groups ?? []).forEach((group) => {
      setAddGroupGeneral((prevGroups) => [...prevGroups, group]);
    });
    const updateUserCoRole = item.role_name;
    setSelectedGroups((prev) => [...prev]);
    setCoUserRoleId(updateUserCoRole);
    const initialUserUpdate =
      item.agent_status_id == "1"
        ? "Accept Chat"
        : item.agent_status_id == "2"
          ? "Don't Accept chats"
          : item.agent_status_id == "3"
            ? "According to working hours"
            : null;
    setUserUpdate(initialUserUpdate);
    setUserRole(item.role_name);
  }, []);

  const isAnyFieldTouched = Object.values(touchedFields).some(Boolean);
  const [userKBRole, setUserKBRole] = useState("");
  const uRole = userData.response?.user?.role_name || coUserData?.response?.user?.role_name;
  console.log("uRole", uRole);
  const socketRef = useRef();

  const handleUpdateChatStatus = (agentId, status) => {
    if (agentId === userId) {
      setAcceptChat(status);
    }
  };
  const isAnyFieldActuallyChanged = useMemo(() => {
    // Convert to numbers for proper comparison
    const currentChatLimit = Number(chatLimit)
    const initialChatLimit = Number(initialProfile.chatLimit);

    return (
      userName !== initialProfile.userName ||
      jobTitle !== (initialProfile.jobTitle || "") ||
      userEmail !== initialProfile.userEmail ||
      currentChatLimit !== initialChatLimit ||
      editLogoSrc !== null
    );
  }, [userName, jobTitle, userEmail, chatLimit, editLogoSrc, initialProfile]);

  useEffect(() => {
    socketRef.current = createAppSocket();
    socketRef.current.on("get-status", handleUpdateChatStatus);
    return () => {
      socketRef.current.off("get-status", handleUpdateChatStatus);
    };
  }, []);
  const handleChatLimitChange = (newLimit) => {
    const numericLimit = Number(newLimit);
    setChatLimit(numericLimit);
    setGetChatLimit(numericLimit);

    setTouchedFields((prev) => ({
      ...prev,
      chatLimit: Number(newLimit) !== Number(initialProfile.chatLimit)
    }));
  };
  const handleGoBack = () => {
    navigate(-1);
  };
  const chracterPosition = (alphabet) => {
    const alphabets = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const positionOfAlphabet = alphabets.indexOf(alphabet) + 1;
    return positionOfAlphabet;
  };
  const colorCodesForAvatar = [
    "#405261", // A
    "#FF4D4F", // B
    "#FA541C", // C
    "#FA8C16", // D
    "#FAAD14", // E
    "#EB2F96", // F
    "#FADB14", // G
    "#A0D911", // H
    "#52C41A", // I
    "#5CDBD3", // J
    "#9254DE", // K
    "#F759AB", // L
    "#2F54EB", // M
    "#722ED1", // N
    "#1890FF", // O
    "#13C2C2", // P
    "#2DB7F5", // Q
    "#19BE6B", // R
    "#30A745", // S
    "#FA8C16", // T
    "#FAAD14", // U
    "#9254DE", // V
    "#F759AB", // W
    "#13C2C2", // X
    "#722ED1", // Y
    "#2DB7F5", // Z
  ];
  const getUserlList = useCallback(
    async (options = {}) => {
      const { background = false } = options;
      if (!userId) return;
      if (!background) {
        setIsLoadingUser(true);
        setIsStatusLoading(true);
      }
      const listCoUserList = dispatch(
        ListUserIndApi({
          id: userId,
        })
      );
      listCoUserList
        .then(async (data) => {
          if (typeof data.payload === "undefined") {
            toast.error("Some Error Occurred. Please try again later.", {
              /* ... */
            });
          } else if (data?.payload?.status === 200) {
            const item = data?.payload?.data;
            console.log("item", item, item.kbRole?.role);
            applyUserListItemToState(item);
            mergeProfileSettingsWarmCache({
              userId,
              userPayload: item,
              hasFetchedProfile: true,
            });
          } else if (data?.payload?.status === 500) {
            toast.error("Some Error Occurred. Please try again later.", {
              /* ... */
            });
            setIsStatusLoading(false);
          } else if (data?.payload?.status === 401) {
            toast.error("Login Expired. Please login and try again.", {
              /* ... */
            });
            setIsStatusLoading(false);
          }
        })
        .catch(async (error) => {
          toast.error(error, {
            /* ... */
          });
          setIsStatusLoading(false);
        })
        .finally(() => {
          if (!background) setIsLoadingUser(false);
        });
    },
    [userId, dispatch, applyUserListItemToState]
  );

  const workingHoursByID = useCallback(
    async (options = {}) => {
      const { background = false } = options;
      if (!userId) return;
      if (!background) setIsLoadingWorkingHours(true);
      const listWorkingHours = dispatch(
        listWorkingHoursApi({
          id: userId,
        })
      );
      listWorkingHours
        .then(async (data) => {
          if (typeof data.payload === "undefined") {
            toast.error("Some Error Occurred. Please try again later.", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
          } else if (data?.payload?.status === 200) {
            const rows = Array.isArray(data?.payload?.data) ? data.payload.data : [];
            const outputarray =
              rows.length > 0
                ? rows.map((item) => ({
                    day: item?.day_of_week,
                    start_time: item?.start_time,
                    end_time: item?.end_time,
                    is_available: item?.is_available,
                  }))
                : [];
            setWorkingData(outputarray);
            mergeProfileSettingsWarmCache({
              userId,
              workingData: outputarray,
              hasFetchedWorkingHours: true,
            });
          } else if (data?.payload?.status === 500) {
            toast.error("Some Error Occurred. Please try again later.", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
          } else if (data?.payload?.status === 401) {
            toast.error("Login Expired. Please login and try again.", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
          }
        })
        .catch(async (error) => {
          toast.error(error, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        })
        .finally(() => {
          if (!background) setIsLoadingWorkingHours(false);
        });
    },
    [userId, dispatch]
  );

  useLayoutEffect(() => {
    if (!userId) {
      setIsLoadingUser(false);
      setIsLoadingWorkingHours(false);
      return;
    }
    const wf = getProfileWarmBootstrapForUser(userId);
    setIsLoadingUser(!wf.profileReady);
    setIsLoadingWorkingHours(!wf.hoursReady);
    const e = getProfileWarmEntry(userId);
    const profileWarm = !!(e?.hasFetchedProfile && e?.userPayload);
    const hoursWarm = !!(e?.hasFetchedWorkingHours && Array.isArray(e?.workingData));

    if (profileWarm) {
      applyUserListItemToState(e.userPayload);
      setIsLoadingUser(false);
    }
    if (hoursWarm) {
      setWorkingData(e.workingData);
      setIsLoadingWorkingHours(false);
    }

    if (profileWarm && hoursWarm) {
      getUserlList({ background: true });
      workingHoursByID({ background: true });
    } else if (profileWarm && !hoursWarm) {
      getUserlList({ background: true });
      workingHoursByID({ background: false });
    } else if (!profileWarm && hoursWarm) {
      getUserlList({ background: false });
      workingHoursByID({ background: true });
    } else {
      getUserlList({ background: false });
      workingHoursByID({ background: false });
    }
  }, [userId, getUserlList, workingHoursByID, applyUserListItemToState]);
  // console.log('in44', initialProfile)
  const updateUserHandler = async () => {
    const { formData, hasChanges } = buildCoUserProfileUpdateFormData({
      userName,
      userEmail,
      userPassword,
      image,
      chatLimit,
      jobTitle,
      initialProfile,
    });

    if (!hasChanges) {
      toast.info("No changes to save");
      return;
    }

    setIsUpdating(true);

    const updateUserResult = dispatch(
      updateCoUserApi({
        id: userId,
        formData,
      })
    );

    updateUserResult
      .then(async (data) => {
        if (typeof data.payload === "undefined") {
          toast.error("Some Error Occurred. Please try again later.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else if (data.payload.status === 200) {
          toast.success("User Updated successfully.");
          getUserlList({ background: true })
          setInitialProfile({
            userName: data.payload.data.full_name || "",
            userEmail: data.payload.data.email || "",
            chatLimit: data.payload.data.agent_chat_limit,
            userLogo: data.payload.data.agent_image || null,
            jobTitle: jobTitle,
            userRole: data.payload.data.user_role || "",
          });
          if (data.payload.data._id === uID) {
            const storedLoginToken = localStorage.getItem("persist:root");
            if (storedLoginToken) {
              const parsedRoot = JSON.parse(storedLoginToken);
              let loginToken = JSON.parse(parsedRoot.loginToken);

              if (
                loginToken &&
                loginToken.response &&
                loginToken.response.user
              ) {
                loginToken.response.user.full_name =
                  data.payload.data.full_name;
                loginToken.response.user.agent_image =
                  data.payload.data.agent_image;

                parsedRoot.loginToken = JSON.stringify(loginToken);
                localStorage.setItem(
                  "persist:root",
                  JSON.stringify(parsedRoot)
                );

                dispatch(
                  updateUser({
                    user: {
                      full_name: data.payload.data.full_name,
                      agent_image: data.payload.data.agent_image,
                    },
                  })
                );
              }
            }
          }
        } else if (data?.payload?.status === 500) {
          toast.error("Some Error Occurred. Please try again later.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
      })
      .catch(async (error) => {
        toast.error(error, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      })
      .finally(() => {
        setIsUpdating(false);

        setTouchedFields({
          userName: false,
          jobTitle: false,
          userEmail: false,
          chatLimit: false,
          userLogo: false,
        });
      });
  };

  const suspendUserHandler = async () => {
    const suspendUserList = dispatch(
      suspendUserApi({
        requestHeaders: { id: userId },
      })
    );
    suspendUserList
      .then(async (data) => {
        if (typeof data.payload === "undefined") {
          toast.error("Some Error Occurred. Please try again later.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else if (data?.payload?.status === 200) {
          toast.success(data?.payload?.message);
          navigate(-1);
        } else if (data?.payload?.status === 500) {
          toast.error("Some Error Occurred. Please try again later.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
      })
      .catch(async (error) => {
        toast.error(error, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      });
  };

  const deleteUserHandler = async () => {
    const deleteuserList = dispatch(
      deleteUserApi({
        requestHeaders: { id: userId },
      })
    );

    deleteuserList
      .then(async (data) => {
        if (typeof data.payload === "undefined") {
          console.log(data);
          toast.error("Some Error Occurred. Please try again later.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else if (data?.payload?.status === 200) {
          toast.success(data?.payload?.message);
          navigate(-1);
        } else if (data?.payload?.status === 500) {
          toast.error("Some Error Occurred. Please try again later.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
      })
      .catch(async (error) => {
        toast.error(error, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      });
  };

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setEditLogoSrc(URL.createObjectURL(file));
      setTouchedFields((prev) => ({ ...prev, userLogo: true }));
    }
  };

  useEffect(() => {
    if (getChatLimit !== "") {
      setChatLimit(getChatLimit);
    }
  }, [getChatLimit]);




  const handleReset = () => {
    setTouchedFields({
      userName: false,
      jobTitle: false,
      userEmail: false,
      chatLimit: false,
      userLogo: false,
    });
    setJobTitle(initialProfile.jobTitle || "");
    setUserName(initialProfile.userName || "");
    setUserEmail(initialProfile.userEmail || "");
    setUserLogo(initialProfile.userLogo || null);
    setChatLimit(initialProfile.chatLimit || 3);
    setUserRole(initialProfile.userRole || "");
    setEditLogoSrc(null); // Remove preview if any
    // Reset other fields as needed
  };

  // Skeleton Loading
  if (isLoadingUser) {
    return (
      <ProfileSettingsUnifiedSkeleton
        showProfileComponent={showProfileComponent}
        uRole={uRole}
        userId={userId}
        uID={uID}
      />
    );
  }


  const handleUserNameChange = (e) => {
    const newValue = e.target.value;

    // Block typing if exceeds 24 characters
    if (newValue.length > 24) {
      setStateName((prev) => ({
        ...prev,
        nameInvalid: true,
        nameInvalidMessage: "Name cannot exceed 24 characters",
        nameState: false,
      }));
      return; // Don't allow the change
    }

    // Allow typing
    setUserName(newValue);

    const value = newValue.trim();
    let errorMsg = "";

    if (!value) {
      errorMsg = "Full name is required";
    } else if (value.length < 3) {
      errorMsg = "Name must be at least 3 characters";
    } else if (specialCharacterRegex.test(value)) {
      errorMsg = "Special characters are not allowed";
    }

    setStateName((prev) => ({
      ...prev,
      nameInvalid: !!errorMsg,
      nameInvalidMessage: errorMsg,
      nameState: !errorMsg,
    }));

    setTouchedFields((prev) => ({
      ...prev,
      userName: newValue !== initialProfile.userName,
    }));
  };



  return (
    <>
      {showProfileComponent ? (
        <>
          <div style={{
            paddingLeft: '24px',
            paddingRight: 0,
            paddingTop: 0,
            paddingBottom: 0,
            marginTop: '19px'
          }} className="EditBack-profile" onClick={() => handleGoBack()}>
            <BACKBUTTON />
            <div>
              <p className="Edit-profile-Button">Edit Profile</p>
            </div>
          </div>
          <div className="ActivePrifle-Container">
            <div className="ProfileInformation-container">
              <div className="" >
                <div className="Active-Profile-Main">
                  <div
                    className="EDITGROUP-LOGO-MAIN"
                    style={{ position: "relative" }}
                  >
                    <div
                      style={{ position: "relative", display: "inline-block" }}
                    >
                      {editLogoSrc ? (
                        <Avatar
                          src={editLogoSrc}
                          alt="user01 Logo"
                          sx={{
                            width: 56,
                            height: 56,
                            borderRadius: "32px",
                          }}
                        />
                      ) : userLogo ? (
                        <Avatar
                          src={userLogo}
                          alt="user02 Logo"
                          sx={{
                            width: 56,
                            height: 56,
                            borderRadius: "32px",
                          }}
                        />
                      ) : (
                        <Avatar
                          src={EDITLOGO}

                          sx={{
                            width: 56,
                            height: 56,
                            bgcolor:
                              colorCodesForAvatar[
                              chracterPosition(
                                agentName
                                  .substring(0, 1)
                                  .toUpperCase()
                              )
                              ],
                          }}
                        >
                          {agentName
                            .substring(0, 1)
                            .toUpperCase()}
                        </Avatar>
                      )}

                      {/* Status Dot - Positioned at bottom-right */}
                      <span
                        style={{
                          position: "absolute",
                          bottom: "0px",
                          right: "0px",
                          zIndex: 2,
                        }}
                      >
                        {!isStatusLoading && isOffline ? (
                          <GreyDot />
                        ) : acceptChat ? (
                          <GreenDot />
                        ) : (
                          <RedDot />
                        )}

                      </span>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "4px",
                      }}
                    >
                      <p style={{ textTransform: 'capitalize' }} className="Edit-profileText">{userName}</p>
                      <p className="EditAgent-profile">
                        {userRole.charAt(0).toUpperCase() + userRole.slice(1)}
                      </p>
                    </div>
                  </div>
                  <button
                    className="EditGroup-Active"
                    type="button"
                    onClick={handleButtonClick}
                  >
                    Upload Image
                  </button>
                </div>
                <div className="Edit-Group-Main-Button">
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleImageChange}
                    style={{ display: "none" }}
                    ref={fileInputRef}
                  />
                </div>

                <div className="">
                  <div className="Profile-Input-Container">
                    <Input
                      title="Full name"
                      placeholder="Enter your full name"
                      value={userName}
                      minLength={3}
                      error={stateName.nameInvalidMessage}
                      className={clsx(
                        stateName.nameInvalid ? 'input__error' : '',

                      )}
                      onChange={handleUserNameChange}
                      required
                    />


                    <Input
                      title="Email"
                      placeholder="Enter your email address"
                      value={userEmail}
                      onChange={(e) => {
                        setUserEmail(e.target.value);
                        setTouchedFields((prev) => ({
                          ...prev,
                          userEmail: true,
                        }));
                      }}
                      disable={true}
                    />
                  </div>
                  <div className="Profile-Input-Container01">
                    <Input
                      title="Job title"
                      value={jobTitle}
                      onChange={(e) => {
                        const newValue = e.target.value;
                        setJobTitle(newValue);
                        // Only mark as touched if there's actual content
                        setTouchedFields((prev) => ({
                          ...prev,
                          jobTitle: newValue.trim() !== (initialProfile.jobTitle || ""),
                        }));
                      }}
                      placeholder="Enter your job title"
                    />
                    <div style={{ width: "100%" }}>
                      <TeamInputNumber
                        value={chatLimit}
                        setGetChatLimit={handleChatLimitChange}
                        title="Chat limit"
                        placeholder="Select option"
                      />
                      <span
                        style={{
                          color: "#93A1B0",
                          fontSize: "10px",
                          fontFamily: "inter",
                        }}
                      >
                        3 is optimal for rookies
                      </span>
                    </div>
                  </div>
                </div>
                {isAnyFieldActuallyChanged && !isUpdating && (
                  <div
                    style={{ marginTop: "36px" }}
                    className="Addworking-button-container"
                  >
                    <button
                      className="addworking-reset"
                      type="button"
                      onClick={handleReset}
                    >
                      Cancel
                    </button>
                    <button
                      className={`Profile-upload-button ${(!userName.trim() || stateName.nameInvalid || isUpdating) ? "disabled-button" : ""}`}
                      type="button"
                      onClick={updateUserHandler}
                      style={{
                        borderColor: (!userName.trim() || stateName.nameInvalid) ? "#C5CED6" : "#148DFD",
                        backgroundColor: (!userName.trim() || stateName.nameInvalid) ? "#F9FAFA" : "#148DFD",
                        color: (!userName.trim() || stateName.nameInvalid) ? "#93A1B0" : "#fff",
                        cursor: (!userName.trim() || stateName.nameInvalid) ? "not-allowed" : "pointer",
                      }}
                      disabled={!userName.trim() || stateName.nameInvalid || isUpdating}
                    >
                      {isUpdating ? "Updating..." : "Save"}
                    </button>
                  </div>
                )}

              </div>
            </div>


            <>
              <p className="Profile-Line-Bottom" />
              <div className="EditProfile-Section">
                <p className="profileInformation">
                  Member of {addGroupGeneral.length} groups
                </p>
                <div className="Profile-Input-Container-Group">
                  <div>
                    <p className="input-div">Assign to groups</p>
                    <CoUserGroup
                      selectedGroups={selectedGroups}
                      setSelectedGroups={setSelectedGroups}
                      setAddNewGroupUser={setAddNewGroupUser}
                      addGroupGeneral={addGroupGeneral}
                      setAddGroupGeneral={setAddGroupGeneral}
                    />
                  </div>
                </div>
                <GeneralSale
                  getUserlList={getUserlList}
                  userId={userId}
                  addGroupGeneral={addGroupGeneral}
                  setAddGroupGeneral={setAddGroupGeneral}
                  addNewGrouptoUser={addNewGrouptoUser}
                />
              </div>
            </>


            <p className="Profile-Line-Bottom" />
            <div className="ProfileInformation-container">
              <p className="profileInformation">
                Agent status after logging in
              </p>
              <br />
              <EditAgentStatus
                activeEditAgentId={activeEditAgentId}
                setActiveEditAgentId={setActiveEditAgentId}
                getUserlList={getUserlList}
                userUpdate={userUpdate}
                userId={userId}
              />
            </div>

            {activeEditAgentId === "3" && (
              <div className="Avaliablity-Container">
                <p
                  style={{ width: "50%", margin: "0 auto 20px auto" }}
                  className="profileInformation-setting"
                >
                  Availability Settings
                </p>
                {isLoadingWorkingHours ? (
                  <Box
                    sx={{ display: "flex", flexDirection: "column", gap: 2 }}
                  >
                    {[...Array(7)].map((_, index) => (
                      <Box
                        key={index}
                        sx={{ display: "flex", gap: 2, alignItems: "center" }}
                      >
                        <Skeleton variant="text" width={80} height={24} />
                        <Skeleton
                          variant="rectangular"
                          width={100}
                          height={40}
                        />
                        <Skeleton variant="text" width={20} height={24} />
                        <Skeleton
                          variant="rectangular"
                          width={100}
                          height={40}
                        />
                        <Skeleton
                          variant="rectangular"
                          width={60}
                          height={32}
                        />
                      </Box>
                    ))}
                  </Box>
                ) : (
                  <AvalibityProfile workingData={workingData} />
                )}
              </div>
            )}
            {userRole === "admin_with_billing" && (
              <>
                <p className="Profile-Line-Bottom" />
                <div className="ProfileInformation-container">
                  <div
                    style={{ width: "100%" }}
                    className="ProfileInformation-container"
                  >
                    <p className="profileInformation">Role and permissions</p>

                    <p
                      style={{
                        fontWeight: "400",
                        marginTop: "20px",
                      }}
                      className="Change-owner-text"
                    >
                      You’re the owner and have all permissions.
                    </p>

                    <button className="Change-owner-button" type="button">
                      <span className="Change-owner-text">Change Owner</span>
                    </button>
                  </div>
                </div>
                <p className="Profile-Line-Bottom" />
                <div
                  style={{ width: "100%" }}
                  className="ProfileInformation-container"
                >
                  <div className="ProfileInformation-container">
                    <p className="profileInformation">Email updates</p>
                    <EditProfileEmail />
                  </div>
                </div>
              </>
            )}
            {(uRole === "admin" ||
              (uRole === "admin_with_billing" && userId !== uID)) && (
                <>
                  <p className="Profile-Line-Bottom" />
                  <div className="ProfileInformation-container">
                    <p className="profileInformation">Role and permissions</p>
                    <br />
                    <RoleAgent
                      getUserlList={getUserlList}
                      userId={userId}
                      coUserRoleId={coUserRoleId}
                    />
                    <KnowledgeBaseRole userId={userId} getUserlList={getUserlList} kbRole={userKBRole} businessId={userData?.response?.user?.business_id} />
                  </div>
                  <p className="Profile-Line-Bottom" />
                  <div className="ProfileInformation-container">
                    <p className="profileInformation">Email updates</p>
                    <EditProfileEmail />
                  </div>
                </>
              )}
            {uRole === "agent" && (
              <>
                <p className="Profile-Line-Bottom" />
                <div className="ProfileInformation-container">
                  <p className="profileInformation">Email updates</p>
                  <EditProfileEmail />
                </div>
              </>
            )}
            {(uRole !== "agent" && userRole === 'agent') && (
              <>
                <p className="Profile-Line-Bottom" />
                <div className="ProfileInformation-container">
                  <p className="profileInformation">Suspend agent</p>
                  <div className="Suspend-agent-container">
                    <p className="suspentagent-text">
                      This will block agent's access to LiveChat. They won't
                      be able to log back in unless reactivated. Note:
                      Suspending an agent won't reduce the number of paid
                      accounts on your Subscription.
                    </p>
                    <button
                      className="Suspend-agent-button"
                      onClick={suspendUserHandler}
                      type="button"
                    >
                      Suspend agent
                    </button>
                  </div>
                </div>
                <p className="Profile-Line-Bottom" />
                <div className="ProfileInformation-container">
                  <p className="profileInformation">Delete agent</p>
                  <div className="Suspend-agent-container">
                    <p className="suspentagent-text">
                      This will delete the agent permanently from your
                      LiveChat account. Note: deleting an agent won't reduce
                      the number of paid accounts on your Subscription.
                    </p>
                    <button
                      className="Suspend-delete-button"
                      type="button"
                      onClick={deleteUserHandler}
                    >
                      Delete agent
                    </button>
                  </div>
                </div>
              </>
            )}

            <p className="Profile-Separator" />
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}
              className="ProfileInformation-container"
            >


              <button className={`Profile-upload-button`} type="button">
                {"Save Changes"}
              </button>
            </div>
          </div>
          <br />
          <br />
        </>
      ) : (
        <div
          className="profile-main-container"
          style={{ width: "100%", minWidth: 0, boxSizing: "border-box" }}
        >
          <div className="profile-settings-layout-row">
            <div className="profile-settings-layout-sidebar">
              <Typography
                sx={{
                  color: "#061522",
                  fontFamily: "Inter",
                  fontSize: "18px",
                  fontWeight: 500,
                  lineHeight: "18px",
                  marginBottom: "8px",
                }}
              >
                Profile Information
              </Typography>
              <Typography
                sx={{
                  color: "#405261",
                  fontFamily: "Inter",
                  fontSize: "14px",
                  fontWeight: 400,
                  lineHeight: "22px",
                  marginBottom: 0,
                }}
              >
                A complete profile helps teammates recognize and connect with
                you
              </Typography>
            </div>

            <div className="profile-settings-layout-content">
              <div className="Active-Profile-Main">
                <div
                  className="EDITGROUP-LOGO-MAIN"
                  style={{ position: "relative" }}
                >
                  <div
                    style={{ position: "relative", display: "inline-block" }}
                  >
                    {editLogoSrc ? (
                      <Avatar
                        src={editLogoSrc}
                        alt="user01 Logo"
                        sx={{
                          width: 56,
                          height: 56,
                          borderRadius: "32px",
                        }}
                      />
                    ) : userLogo ? (
                      <Avatar
                        src={userLogo}
                        alt="user02 Logo"
                        sx={{
                          width: 56,
                          height: 56,
                          borderRadius: "32px",
                        }}
                      />
                    ) : (
                      <Avatar
                        src={EDITLOGO}

                        sx={{
                          width: 56,
                          height: 56,
                          bgcolor:
                            colorCodesForAvatar[
                            chracterPosition(
                              userData?.response?.user?.full_name
                                .substring(0, 1)
                                .toUpperCase()
                            )
                            ],
                        }}
                      >
                        {userData?.response?.user?.full_name
                          .substring(0, 1)
                          .toUpperCase()}
                      </Avatar>
                    )}

                    {/* Status Dot - Positioned at bottom-right */}
                    <span
                      style={{
                        position: "absolute",
                        bottom: "0px",
                        right: "0px",
                        zIndex: 2,
                      }}
                    >
                      {isStatusLoading ? (
                        <GreyDot />
                      ) : acceptChat ? (
                        <GreenDot />
                      ) : (
                        <RedDot />
                      )}
                    </span>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "4px",
                    }}
                  >
                    <p style={{ textTransform: 'capitalize' }} className="Edit-profileText">{userName}</p>
                    <p className="EditAgent-profile">
                      {userRole.charAt(0).toUpperCase() + userRole.slice(1)}
                    </p>
                  </div>
                </div>
                <button
                  className="EditGroup-Active"
                  type="button"
                  onClick={handleButtonClick}
                >
                  Upload Image
                </button>
              </div>
              <div className="Edit-Group-Main-Button">
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleImageChange}
                  style={{ display: "none" }}
                  ref={fileInputRef}
                />
              </div>

              <div className="">
                <div className="Profile-Input-Container">
                  <Input
                    title="Full name"
                    placeholder="Enter your full name"
                    value={userName}
                    minLength={3}
                    error={stateName.nameInvalidMessage}
                    className={clsx(
                      stateName.nameInvalid ? 'input__error' : '',

                    )}
                    onChange={handleUserNameChange}
                  />
                  <Input
                    title="Email"
                    placeholder="Enter your email address"
                    value={userEmail}
                    onChange={(e) => {
                      setUserEmail(e.target.value);
                      setTouchedFields((prev) => ({
                        ...prev,
                        userEmail: true,
                      }));
                    }}
                    disable={true}
                  />
                </div>
                <div className="Profile-Input-Container01">
                  <Input
                    title="Job title"
                    value={jobTitle}
                    onChange={(e) => {
                      const newValue = e.target.value;
                      setJobTitle(newValue);
                      // Only mark as touched if there's actual content
                      setTouchedFields((prev) => ({
                        ...prev,
                        jobTitle: newValue.trim() !== (initialProfile.jobTitle || ""),
                      }));
                    }}
                    placeholder="Enter your job title"
                  />
                  <div style={{ width: "100%" }}>
                    <TeamInputNumber
                      value={chatLimit}
                      setGetChatLimit={handleChatLimitChange}
                      title="Chat limit"
                      placeholder="Select option"
                    />
                    <span
                      style={{
                        color: "#93A1B0",
                        fontSize: "10px",
                        fontFamily: "inter",
                      }}
                    >
                      3 is optimal for rookies
                    </span>
                  </div>
                </div>
              </div>
              {isAnyFieldActuallyChanged && !isUpdating && (
                <div
                  style={{ marginTop: "36px" }}
                  className="Addworking-button-container"
                >
                  <button
                    className="addworking-reset"
                    type="button"
                    onClick={handleReset}
                  >
                    Cancel
                  </button>
                  <button
                    className={`Profile-upload-button ${(!userName.trim() || stateName.nameInvalid || isUpdating) ? "disabled-button" : ""}`}
                    type="button"
                    onClick={updateUserHandler}
                    style={{
                      borderColor: (!userName.trim() || stateName.nameInvalid) ? "#C5CED6" : "#148DFD",
                      backgroundColor: (!userName.trim() || stateName.nameInvalid) ? "#F9FAFA" : "#148DFD",
                      color: (!userName.trim() || stateName.nameInvalid) ? "#93A1B0" : "#fff",
                      cursor: (!userName.trim() || stateName.nameInvalid) ? "not-allowed" : "pointer",
                    }}
                    disabled={!userName.trim() || stateName.nameInvalid || isUpdating}
                  >
                    {isUpdating ? "Updating..." : "Save"}
                  </button>
                </div>
              )}

            </div>
          </div>


          <>
            <p className="Profile-Separator" />
            <div className="profile-settings-layout-row">
              <div
                className="profile-settings-layout-sidebar profile-settings-layout-sidebar--spacer"
                aria-hidden="true"
              />
              <div className="profile-settings-layout-content">
                <p className="profileInformation">
                  Member of {addGroupGeneral.length} groups
                </p>
                <div className="Profile-Input-Container-Group">
                  <div>
                    <p className="input-div">Assign to groups</p>
                    <CoUserGroup
                      userID={userId}
                      selectedGroups={selectedGroups}
                      setSelectedGroups={setSelectedGroups}
                      setAddNewGroupUser={setAddNewGroupUser}
                      addGroupGeneral={addGroupGeneral}
                      setAddGroupGeneral={setAddGroupGeneral}
                    />
                  </div>
                </div>
                <GeneralSale
                  getUserlList={getUserlList}
                  userId={userId}
                  addGroupGeneral={addGroupGeneral}
                  setAddGroupGeneral={setAddGroupGeneral}
                  addNewGrouptoUser={addNewGrouptoUser}
                />
              </div>
            </div>
          </>


          <p className="Profile-Separator" />
          <div style={{ width: "100%", minWidth: 0, boxSizing: "border-box" }}>
            <div className="profile-settings-layout-row">
              <div
                className="profile-settings-layout-sidebar profile-settings-layout-sidebar--spacer"
                aria-hidden="true"
              />
              <div
                className="profile-settings-layout-content"
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <p className="profileInformation">
                  Agent status after logging in
                </p>
                <br />
                <EditAgentStatus
                  activeEditAgentId={activeEditAgentId}
                  setActiveEditAgentId={setActiveEditAgentId}
                  getUserlList={getUserlList}
                  userUpdate={userUpdate}
                  userId={userId}
                />
                {activeEditAgentId === "3" && (
                  <div className="">
                    <p className="profileInformation-setting">
                      Availability Settings
                    </p>
                    {isLoadingWorkingHours ? (
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                        }}
                      >
                        {[...Array(7)].map((_, index) => (
                          <Box
                            key={index}
                            sx={{
                              display: "flex",
                              gap: 2,
                              alignItems: "center",
                            }}
                          >
                            <Skeleton variant="text" width={80} height={24} />
                            <Skeleton
                              variant="rectangular"
                              width={100}
                              height={40}
                            />
                            <Skeleton variant="text" width={20} height={24} />
                            <Skeleton
                              variant="rectangular"
                              width={100}
                              height={40}
                            />
                            <Skeleton
                              variant="rectangular"
                              width={60}
                              height={32}
                            />
                          </Box>
                        ))}
                      </Box>
                    ) : (
                      <AvalibityProfile
                        userID={userId}
                        workingData={workingData}
                      />
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>

          {(uRole === "agent" || uRole === "admin") && (
            <>
              <p className="Profile-Separator" />
              <div className="profile-settings-layout-row">
                <div
                  className="profile-settings-layout-sidebar profile-settings-layout-sidebar--spacer"
                  aria-hidden="true"
                />
                <div
                  className="profile-settings-layout-content"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div
                    style={{ width: "100%" }}
                    className="ProfileInformation-container"
                  >
                    <p className="profileInformation">Email updates</p>
                    <EditProfileEmail />
                  </div>
                </div>
              </div>
            </>
          )}
          {uRole === "admin_with_billing" && (
            <>
              <p className="Profile-Separator" />
              <div className="profile-settings-layout-row">
                <div
                  className="profile-settings-layout-sidebar profile-settings-layout-sidebar--spacer"
                  aria-hidden="true"
                />
                <div
                  className="profile-settings-layout-content"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div
                    style={{ width: "100%" }}
                    className="ProfileInformation-container"
                  >
                    <p className="profileInformation">Email updates</p>
                    <EditProfileEmail />
                  </div>
                </div>
              </div>
            </>
          )}
          <p className="Profile-Separator" />
          <div className="profile-settings-layout-row">
            <div
              className="profile-settings-layout-sidebar profile-settings-layout-sidebar--spacer"
              aria-hidden="true"
            />
            <div
              className="profile-settings-layout-content"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
              }}
            >
              <button className="Profile-upload-button" type="button">
                Save Changes
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default EditProfileMain;